import { FC } from 'react';
import ToggleSection from 'components/ToggleSection/ToggleSection';

interface PmsPractitionerScheduleToggleSectionProps {
  control: any;
}

const PmsPractitionerScheduleToggleSection: FC<
  PmsPractitionerScheduleToggleSectionProps
> = ({ control }) => {
  return (
    <ToggleSection
      control={control}
      name="isPmsPractitionerSchedulePrioritizedEnabled"
      title="Follow PMS Practitioner Schedule"
    />
  );
};

export default PmsPractitionerScheduleToggleSection;
